import getWindow from "./window";

export const getParamFromReferrer = ({ param }) => {
  const referrer = getWindow().document.referrer;
  return referrer
    ? new URLSearchParams(new URL(referrer).search).get(param) || undefined
    : undefined;
};
